/**
 * appInit.js — App initialization, error handlers, offline UI, modals
 * Extracted from index.html Block 0 (802 lines)
 */
import { log } from '../utils/logger.js';

// [FIX] AbortController для очистки глобальных слушателей
let _ac = new AbortController();

export function initApp() {
// [FIX] Пропускаем loader/showApp — main.js уже это делает
if (window.__appInitDone) return;
window.__appInitDone = true;
// [FIX] Создаём AbortController для cleanup
if (_ac) _ac.abort();
_ac = new AbortController();

// [FIX] _mobileActiveTool и _userHasInteracted уже установлены в htmlInit.js
// Здесь только fallback на случай если htmlInit.js не загрузился
if (window._mobileActiveTool === undefined) window._mobileActiveTool = 'WindowLevel';
if (window._userHasInteracted === undefined) {
  window._userHasInteracted = false;
  ['pointerdown','touchstart'].forEach(function(ev) {
    document.addEventListener(ev, function() { window._userHasInteracted = true; }, { once: true, passive: true , signal: _ac.signal});
  });
}

// [FIX] Апгрейд error handler (htmlInit.js ставит базовый console.error,
// здесь перезаписываем на версию с log + showToast)
window.onerror = function(msg, src, line, col, err) {
  let msgStr = (msg || '').toString();
  // Перехват ошибки лупы на VolumeViewport
  if (msgStr.indexOf('MagnifyTool only works on StackViewports') !== -1) {
    // [FIX] Подавляем ошибку — bindToolbar сам переключает в 2D
    return true;
  }
  log.error('[Global Error]', msg, '\n  at', src, 'line:', line);
  // Охрана смотрела на голое showToast, которого в этом модуле нет: под typeof
  // такое имя даёт 'undefined', условие никогда не выполнялось, и ни одна
  // глобальная ошибка до человека не доходила. Спрашивать надо ровно о том, что
  // потом и зовём, — о window.showToast.
  if (typeof window.showToast === 'function') {
    window.showToast('⚠️ ' + msgStr.substring(0, 120), 'error', 5000);
  }
};
// [FIX] unhandledrejection уже зарегистрирован в htmlInit.js — не дублируем listener,
// но перезаписываем на улучшенную версию через единый обработчик
window._onUnhandledRejection = function(e) {
  let msg = e.reason ? (e.reason.message || String(e.reason)) : 'Async error';
  log.error('[Unhandled Promise]', e.reason);
  if (typeof window.showToast === 'function') {          // та же беда, что и в window.onerror выше
    window.showToast('⚠️ ' + msg.substring(0, 120), 'error', 4000);
  }
};
window.addEventListener('unhandledrejection', window._onUnhandledRejection, { signal: _ac.signal });

// ══════════════════════════════════════════════════════════════
// Обработчики кнопок, которые должны работать ВСЕГДА (не только в offline)
// ══════════════════════════════════════════════════════════════

// Night Mode toggle — чистый CSS
var btnNight = document.getElementById('btn-night-mode');
if (btnNight) btnNight.addEventListener('click', function() {
  var isNight = document.documentElement.classList.toggle('night-warm');
  btnNight.classList.toggle('active', isNight);
});

// [11.1.16] ПЕРВЫЙ обработчик «Кино» (btn-cine-gif) УДАЛЁН — у кнопки было
// ДВА хозяина в одном initApp: этот, сырой canvas.captureStream→MediaRecorder,
// и второй ниже (строкой «[NEW] Cine GIF/WebM recording button»), зовущий
// exportAsGif()/startVideoRecording из exportModule. Guard __appInitDone от
// такого не спасал: он режет повторный ВЫЗОВ initApp, а не второй слушатель
// внутри одного вызова. Один щелчок запускал ОБЕ записи разом; второй гасил
// сырую и запускал ещё один GIF. Оставлен второй путь — он умеет и GIF, и
// видео с режимами. Болезнь та же, что у btn-export-stl в мемориале
// [10.19.10] пятью строками ниже второго обработчика.

// [10.19.10] 3D STL — здесь было СЛОМАНО ТРЕМЯ СПОСОБАМИ СРАЗУ.
//
//  1. Звался api.exportSTL() БЕЗ АРГУМЕНТОВ, а функция требует meshData:
//     первое же обращение к meshData.isA бросало исключение внутрь try/catch,
//     и наружу возвращалось {}.
//  2. Вызывающий проверял result.blob — которого exportSTL не возвращает
//     никогда (она отдаёт {success, sizeKb} и сама скачивает файл).
//  3. На той же кнопке висел ВТОРОЙ обработчик в featureBindings.js,
//     показывавший подсказку «Exporting STL...» — то есть при нажатии человек
//     видел обещание, а файла не получал.
//
// Теперь один хозяин и один путь: сетка строится из активного тома тем же
// marching cubes, что и для glTF/VRML (см. src/ui/toolsBindings.js), и сразу
// уходит в файл. Обработчик — там же, рядом с остальными кнопками 3D-модели.

// Spacebar → Cine play/pause
document.addEventListener('keydown', function(e) {
  if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') return;
  if (e.key === ' ') {
    e.preventDefault();
    var api = window.MikhmelViewer;
    if (!api) return;
    var state = api.getCineState ? api.getCineState() : null;
    if (state && state.playing) {
      api.stopCine();
    } else {
      api.startCine(null, { fps: 12, loop: true });
    }
  }
});

(function() {
  let isFileProtocol = location.protocol === 'file:';
  let loader = document.getElementById('app-loader');
  let app = document.getElementById('app');
  let loaderStatus = loader ? loader.querySelector('.loader-status') : null;

  function showApp() {
    // [FIX] Проверяем — main.js мог уже показать app
    if (app && app.style.display === 'flex') return;
    if (loader) loader.style.display = 'none';
    if (app) app.style.display = 'flex';
  }

  if (!isFileProtocol) {
    // === SERVER MODE: main.js загружается через статический тег ниже ===
    // Vite при build заменит src на хэшированное имя бандла
    if (loaderStatus) loaderStatus.textContent = 'Загрузка Cornerstone3D...';
    // Fallback: если через 15с приложение не загрузилось — показываем UI-only
    setTimeout(function() {
      if (app && app.style.display !== 'flex') {
        log.warn('[Mikhmel4D] Module load timeout, falling back to UI-only');
        showApp();
        initOfflineUI();
      }
    }, 15000);
  } else {
    // === FILE:// MODE: UI-only без Cornerstone ===
    if (loaderStatus) loaderStatus.textContent = 'file:// — просмотр интерфейса';
    setTimeout(showApp, 500);
    initOfflineUI();
  }

  function initOfflineUI() {
    // Если uiManager.js уже привязал обработчики — не дублируем
    if (window.__uiManagerReady) return;
    window.__offlineUIReady = true;
    // Обработка кнопок topbar
    document.querySelectorAll('.tb-btn[data-layout]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (window.__uiManagerReady) return; // uiManager handles it
        document.querySelectorAll('.tb-btn[data-layout]').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
      }, { signal: _ac.signal });
    });
    document.querySelectorAll('.tb-btn[data-mode]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (window.__uiManagerReady) return;
        document.querySelectorAll('.tb-btn[data-mode]').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        // [FIX] Вызываем activateViewMode для переключения проекции + скролл колёсиком
        let mode = btn.dataset.mode;
        if (mode && window.MikhmelViewer && window.MikhmelViewer.activateViewMode) {
          window.MikhmelViewer.activateViewMode(mode);
        }
      }, { signal: _ac.signal });
    });

    // Toolbar tool buttons
    document.querySelectorAll('.tool-btn[data-tool]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (window.__uiManagerReady) return;
        document.querySelectorAll('.tool-btn').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        let label = document.getElementById('active-tool-label');
        if (label) label.textContent = btn.dataset.tool;
      }, { signal: _ac.signal });
    });

    // [11.1.18] Ранний слой подсветки чипов W/L УДАЛЁН (решение согласовано
    // ответом владельца «сделай на своё усмотрение»). После 11.1.17 чипы
    // рождаются ПОЗЖЕ этого кода — их строит из каталога
    // sidebarBindings.построитьЧипыОкон, — и forEach здесь пробегал по
    // пустоте: слой не делал ничего и никого не ждал (штатный гаситель
    // __uiManagerReady при этом цел и сторожит соседние слои ниже).
    // 3D render presets (right panel preset-chip)
    document.querySelectorAll('.preset-chip[data-render-preset]').forEach(function(chip) {
      chip.addEventListener('click', function() {
        if (window.__uiManagerReady) return;
        document.querySelectorAll('.preset-chip[data-render-preset]').forEach(function(c) { c.classList.remove('active'); });
        document.querySelectorAll('.sl-vrt-btn[data-render-preset]').forEach(function(c) { c.classList.remove('active'); });
        chip.classList.add('active');
        let preset = chip.dataset.renderPreset;
        document.querySelectorAll('.sl-vrt-btn[data-render-preset="' + preset + '"]').forEach(function(b) { b.classList.add('active'); });
      }, { signal: _ac.signal });
    });

    // 3D VRT presets (left panel sl-vrt-btn)
    document.querySelectorAll('.sl-vrt-btn[data-render-preset]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (window.__uiManagerReady) return;
        document.querySelectorAll('.sl-vrt-btn[data-render-preset]').forEach(function(c) { c.classList.remove('active'); });
        btn.classList.add('active');
        let preset = btn.dataset.renderPreset;
        let rightChip = document.querySelector('.preset-chip[data-render-preset="' + preset + '"]');
        if (rightChip) rightChip.click();
      }, { signal: _ac.signal });
    });

    // Orientation buttons (left panel)
    document.querySelectorAll('.sl-orient-btn[data-std-view]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (window.__uiManagerReady) return;
        document.querySelectorAll('.sl-orient-btn').forEach(function(c) { c.style.borderColor = ''; });
        btn.style.borderColor = 'var(--accent)';
        let view = btn.dataset.stdView;
        let rightChip = document.querySelector('.preset-chip[data-std-view="' + view + '"]');
        if (rightChip) rightChip.click();
      }, { signal: _ac.signal });
    });


    // [11.0.2] Блок кинематики удалён: он трогал ТРИ кнопки, которых нет в
    // разметке — btn-cinematic-left, cine-toggle-btn, btn-cinematic-toggle.
    // Первая переехала в ui/featureBindings ещё в 10.19.16 (см. надгробие в
    // sidebarBindings), вторая убрана в 10.19.19, третьей не было никогда.
    // Здесь оставалась их подпись и цвет рамки — работа над пустотой.

    // [11.0.2] Пустышка «Вписать» удалена. Она вешалась на btn-fit-view-left
    // ВТОРЫМ слушателем поверх живого (sidebarBindings, починен в 10.19.16) и
    // не делала ничего: тело обработчика состояло из одного комментария
    // «// Reset camera / fit to window». Сторож её не видел, потому что искал
    // пустышки только в форме `() => {}`; правило расширено [11.0.2].

    // === NEW FEATURE HANDLERS (полные реализации) ===

    // === TAVI ===
    let taviBtn = document.getElementById('btn-tavi');
    if (taviBtn) taviBtn.addEventListener('click', function() {
      document.getElementById('modal-tavi').classList.add('open');
    }, { signal: _ac.signal });
    let taviCalcBtn = document.getElementById('btn-tavi-calc');
    if (taviCalcBtn) taviCalcBtn.addEventListener('click', function() {
      let d = parseFloat(document.getElementById('tavi-annulus-d').value) || 0;
      let p = parseFloat(document.getElementById('tavi-annulus-p').value) || 0;
      let a = parseFloat(document.getElementById('tavi-annulus-a').value) || 0;
      let rec = document.getElementById('tavi-recommendation');

      // Приоритет: периметр → эффективный диаметр (для овального кольца точнее)
      let effectiveD = 0;
      let method = '';
      if (p > 0) {
        // Лучший метод: Deff = Периметр / π (стандарт для TAVI планирования)
        effectiveD = p / Math.PI;
        method = 'По периметру (Deff = P/π)';
        // Автозаполнение D и A если пустые
        if (d === 0) { d = effectiveD; document.getElementById('tavi-annulus-d').value = d.toFixed(1); }
        if (a === 0) { a = p * p / (4 * Math.PI); document.getElementById('tavi-annulus-a').value = a.toFixed(1); }
      } else if (a > 0) {
        // Второй метод: Deff = 2 * √(A/π) (по площади)
        effectiveD = 2 * Math.sqrt(a / Math.PI);
        method = 'По площади (Deff = 2√(A/π))';
        if (d === 0) { d = effectiveD; document.getElementById('tavi-annulus-d').value = d.toFixed(1); }
        if (p === 0) { p = effectiveD * Math.PI; document.getElementById('tavi-annulus-p').value = p.toFixed(1); }
      } else if (d > 0) {
        // Наименее точный: прямой диаметр (предполагает круглое кольцо)
        effectiveD = d;
        method = 'По диаметру (⚠️ кольцо считается круглым)';
        p = d * Math.PI; document.getElementById('tavi-annulus-p').value = p.toFixed(1);
        a = Math.PI * (d/2) * (d/2); document.getElementById('tavi-annulus-a').value = a.toFixed(1);
      } else {
        rec.innerHTML = '<span style="color:var(--warning)">Введите хотя бы один параметр</span>';
        return;
      }

      // Рекомендации по Edwards SAPIEN 3 (по периметру/площади — табличные данные IFU)
      let sapien = '—', sapienOversizing = '';
      let evolut = '—', evolutOversizing = '';
      // SAPIEN 3: по периметру-derived диаметру
      if (effectiveD >= 18 && effectiveD < 20) { sapien = '20mm'; }
      else if (effectiveD >= 20 && effectiveD < 22) { sapien = '23mm'; }
      else if (effectiveD >= 22 && effectiveD < 24.5) { sapien = '23mm'; }
      else if (effectiveD >= 24.5 && effectiveD < 27) { sapien = '26mm'; }
      else if (effectiveD >= 27 && effectiveD < 29.5) { sapien = '29mm'; }
      else if (effectiveD >= 29.5) { sapien = 'Вне диапазона'; }
      else { sapien = 'Вне диапазона (< 18 мм)'; }
      // Evolut: по периметру-derived диаметру
      if (effectiveD >= 18 && effectiveD < 20) { evolut = '23mm'; }
      else if (effectiveD >= 20 && effectiveD < 23) { evolut = '26mm'; }
      else if (effectiveD >= 23 && effectiveD < 26) { evolut = '29mm'; }
      else if (effectiveD >= 26 && effectiveD < 30) { evolut = '34mm'; }
      else if (effectiveD >= 30) { evolut = '34mm (XL)'; }
      else { evolut = 'Вне диапазона (< 18 мм)'; }

      // Предупреждение о расстоянии до коронаров
      let coronaryDist = parseFloat(document.getElementById('tavi-coronary-dist').value) || 0;
      let coronaryWarn = '';
      if (coronaryDist > 0 && coronaryDist < 10) {
        coronaryWarn = '<br><span style="color:var(--error)">⚠️ Расст. до коронаров ' + coronaryDist.toFixed(1) + ' мм < 10 мм — риск окклюзии!</span>';
      }

      rec.innerHTML =
        '<b>Edwards SAPIEN 3:</b> ' + sapien +
        '<br><b>Medtronic CoreValve Evolut:</b> ' + evolut +
        coronaryWarn +
        '<br><small style="color:var(--text-dim)">Метод: ' + method +
        '<br>Deff: ' + effectiveD.toFixed(1) + ' мм | P: ' + p.toFixed(1) + ' мм | A: ' + a.toFixed(1) + ' мм²</small>';
    }, { signal: _ac.signal });
    let taviPdfBtn = document.getElementById('btn-tavi-pdf');
    if (taviPdfBtn) taviPdfBtn.addEventListener('click', function() {
      (window.showToast||function(){})('📄 Экспорт TAVI-отчёта в PDF', 'info');
      // Trigger через report module если доступен
      if (window.MikhmelViewer && window.MikhmelViewer.modules) {
        window.MikhmelViewer.modules.report && window.MikhmelViewer.modules.report().then(function(m) { m.exportTAVI && m.exportTAVI(); });
      }
    }, { signal: _ac.signal });

    // [10.19.30] «ROI Гистогр.» и её кнопка перерисовки УБРАНЫ ОТСЮДА: у обеих
    // было ДВА хозяина — этот файл и featureBindings.js, и оба срабатывали на
    // один клик. Окно открывалось дважды (безвредно), а гистограмма рисовалась
    // ДВАЖДЫ ПОДРЯД двумя разными алгоритмами — побеждал тот, кто успел
    // последним. Единственный хозяин теперь featureBindings.js (bindUtilities).

    // === ROI W/L (Smart Contrast) ===
    // HANDLED BY uiManager.js bindROIWL() — inline handler removed to prevent duplication

    // [10.19.30] «Контраст-граф» и его перерисовка УБРАНЫ ОТСЮДА по той же
    // причине, что и гистограмма выше: два хозяина (этот файл и
    // featureBindings.js), двойное открытие окна и двойная отрисовка кривой на
    // одном холсте. Единственный хозяин — featureBindings.js.

    // === ANONYMIZE ===
    let anonymizeBtn = document.getElementById('btn-anonymize');
    if (anonymizeBtn) anonymizeBtn.addEventListener('click', function() {
      document.getElementById('modal-anonymize').classList.add('open');
    }, { signal: _ac.signal });
    // [10.19.30] Отдельный перещёлкиватель выключателей окна анонимизации
    // УБРАН: их и так ведёт общий bindToggles из sidebarBindings. Вторая
    // подписка означала двойной щелчок класса — и выключатели замирали.
    // [10.19.10] ВТОРОЙ ОБРАБОТЧИК НА btn-anon-run УБРАН ЦЕЛИКОМ.
    //
    // Их было два, и оба рапортовали успех. Этот собирал список из семи тегов и
    // звал window.MikhmelViewer._anonymize(...) под проверкой if — функции с
    // таким именем не существует нигде в src/, так что вызов молча пропускался,
    // а «✅ Обработано тегов: N» печаталось всё равно.
    //
    // Настоящее обезличивание теперь ОДНО и живёт в fileOps.js
    // (_runAnonymization → io/deidentifyRun.js → io/deidentify.js). Два хозяина
    // у одной кнопки — это то, из-за чего поломку и не замечали, поэтому здесь
    // не вешается ничего.
    let anonExportBtn = document.getElementById('btn-anon-export');
    if (anonExportBtn) anonExportBtn.addEventListener('click', function() {
      // [10.19.10] Здесь звался несуществующий _exportAnon, а тост обещал
      // «экспорт анонимизированных файлов», которых никто не делал. Теперь
      // кнопка делает то же, что и «Анонимизировать»: обезличенная КОПИЯ
      // выбранных файлов уходит отдельным ZIP.
      import('../io/deidentifyRun.js')
        .then((m) => m.обезличитьВыбранные())
        .catch((e) => (window.showToast||function(){})('Обезличивание недоступно: ' + e.message, 'error', 6000));
    }, { signal: _ac.signal });

    // === VOICE CONTROL ===
    // [10.19.31] Голосовой блок УБРАН: у btn-voice-control было ТРИ хозяина —
    // инлайн-скрипт index.html (viewportVoice), этот файл и featureBindings.
    // Один клик поднимал ТРИ распознавателя, и «выкл» одного означал «вкл»
    // другого. Хозяин один — featureBindings: там полный словарь русских
    // команд (пресеты, проекции, стоп) и честный отказ без поддержки браузера.

    // [10.19.30] «WebGPU тест» УБРАН ОТСЮДА: второй полный обработчик жил в
    // featureBindings.js, и по одному клику шли ДВЕ проверки — два тоста и
    // гонка за надпись на кнопке (каждый писал своё «⏳/✅/❌»). Единственный
    // хозяин — featureBindings.js: его версия новее и пишет подробности уровня.

    // Right sidebar tabs
    document.querySelectorAll('.right-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        document.querySelectorAll('.right-tab').forEach(function(t) { t.classList.remove('active'); });
        document.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.remove('active'); });
        tab.classList.add('active');
        let panel = document.getElementById(tab.dataset.tab);
        if (panel) panel.classList.add('active');
      }, { signal: _ac.signal });
    });

    // Panel headers collapse/expand
    document.querySelectorAll('.panel-header[data-panel]').forEach(function(header) {
      header.addEventListener('click', function() {
        let panel = document.getElementById(header.dataset.panel);
        if (panel) {
          panel.classList.toggle('collapsed');
          let toggle = header.querySelector('.toggle');
          if (toggle) toggle.textContent = panel.classList.contains('collapsed') ? '▸' : '▾';
        }
      }, { signal: _ac.signal });
    });

    // [10.19.30] Общий перещёлкиватель .ctrl-toggle УБРАН ОТСЮДА: точно такой
    // же живёт в sidebarBindings.js (bindToggles). Два слушателя на одном
    // выключателе щёлкали класс ДВАЖДЫ за клик — «on» → «off» за один тап, и
    // визуально каждый переключатель казался замёрзшим. Хозяин один — sidebar.

    // Range value displays
    document.querySelectorAll('input[type="range"]').forEach(function(range) {
      let valSpan = range.parentElement ? range.parentElement.querySelector('.ctrl-value') : null;
      if (valSpan && !valSpan.id) {
        range.addEventListener('input', function() { valSpan.textContent = range.value; }, { signal: _ac.signal });
      }
    });

    // [11.1.21] Карта rangePairs УДАЛЕНА ЦЕЛИКОМ. Она дублировала
    // sidebarBindings.bindSliderUpdates для ДЕСЯТИ ползунков — при том что
    // надгробие [10.19.28] прямо здесь уже объясняло, чем это кончается:
    // «второй обработчик на том же ползунке… разъедутся молча». Два из
    // десяти дублей (seg-opacity, vol-opacity) писали сырое «60» против
    // «60%» у настоящего хозяина — прикрывал только порядок инициализации.
    // Хозяин подписей один: bindSliderUpdates.

    // File input buttons
    let btnOpenFile = document.getElementById('btn-open-file');
    let btnOpenFolder = document.getElementById('btn-open-folder');
    let fileInput = document.getElementById('file-input');
    let folderInput = document.getElementById('folder-input');
    if (btnOpenFile && fileInput) btnOpenFile.addEventListener('click', function() { fileInput.click(); }, { signal: _ac.signal });
    // [10.1.9] «Папка» идёт через наш обход, а не сразу в скрытый input.
    //
    // Здесь стоял folderInput.click() — то есть выбор папки уходил в
    // <input webkitdirectory>, где список файлов собирает САМ БРАУЗЕР. Пока
    // он это делает, событие change не наступает, наш код не выполняется, и
    // показать нечего: на большом исследовании это несколько минут полной
    // тишины. Обвязка с уведомлением, которую я добавил в 10.1.8, лежала в
    // openFolderPicker и по этой кнопке просто не вызывалась.
    //
    // openFolderPicker сперва пробует showDirectoryPicker — там дерево
    // обходим МЫ и можем показывать счётчик найденных файлов. Если браузер
    // такого не умеет, внутри неё же остаётся прежний путь через input.
    if (btnOpenFolder) btnOpenFolder.addEventListener('click', function() {
      const pick = window.MikhmelViewer?.openFolderPicker;
      if (typeof pick === 'function') { pick(); return; }
      if (folderInput) folderInput.click();
    }, { signal: _ac.signal });

    // Reset button
    let btnReset = document.getElementById('btn-reset');
    if (btnReset) btnReset.addEventListener('click', function() {
      document.querySelectorAll('.preset-chip').forEach(function(c) { c.classList.remove('active'); });
    }, { signal: _ac.signal });

    // Invert button toggle
    let btnInvert = document.getElementById('btn-invert');
    if (btnInvert) btnInvert.addEventListener('click', function() { btnInvert.classList.toggle('active'); }, { signal: _ac.signal });

    // Fullscreen
    let btnFs = document.getElementById('btn-fullscreen');
    if (btnFs) btnFs.addEventListener('click', function() {
      if (!document.fullscreenElement) {
        (document.documentElement.requestFullscreen || document.documentElement.webkitRequestFullscreen || function(){}).call(document.documentElement);
      } else {
        (document.exitFullscreen || document.webkitExitFullscreen || function(){}).call(document);
      }
    }, { signal: _ac.signal });

    // Night Mode toggle — чистый CSS, без импортов
    let btnNight = document.getElementById('btn-night-mode');
    if (btnNight) btnNight.addEventListener('click', function() {
      var isNight = document.documentElement.classList.toggle('night-warm');
      btnNight.classList.toggle('active', isNight);
    }, { signal: _ac.signal });

    // Help modal
    let btnHelp = document.getElementById('btn-help');
    let modalHelp = document.getElementById('modal-help');
    if (btnHelp && modalHelp) btnHelp.addEventListener('click', function() { modalHelp.classList.add('open'); }, { signal: _ac.signal });

    // TF Editor — handled in main.js, skip here to avoid duplicates
    // let btnTFEditor = document.getElementById('btn-tf-editor'); ...

    // DICOM tags modal — [REMOVED] дублировал toolBindings.js

    // WADO modal
    let btnUrl = document.getElementById('btn-open-url');
    let modalWado = document.getElementById('modal-wado');
    if (btnUrl && modalWado) btnUrl.addEventListener('click', function() { modalWado.classList.add('open'); }, { signal: _ac.signal });

    // Archive modal
    let btnArchive = document.getElementById('btn-archive');
    let modalArchive = document.getElementById('modal-archive');
    if (btnArchive && modalArchive) btnArchive.addEventListener('click', function() { modalArchive.classList.add('open'); }, { signal: _ac.signal });

    // Modal close buttons — [REMOVED] дублировал sidebarBindings.js
    // Close modal on overlay click — [REMOVED] дублировал sidebarBindings.js
    // Блокировка viewport при модалке (Аудит п.5)
    // [REFACTOR] Modal check via EventBus
    let _modalActiveCheck = new MutationObserver(function() {
      let hasOpen = document.querySelector('.modal-overlay.open');
      document.body.classList.toggle('modal-active', !!hasOpen);
    });
    document.querySelectorAll('.modal-overlay').forEach(function(ov) {
      _modalActiveCheck.observe(ov, { attributes: true, attributeFilter: ['class'] });
    });

    // Sidebar toggles — [REMOVED] дублировал sidebarBindings.js

    // CINE bar toggle via Space
    let cineBar = document.getElementById('cine-bar');
    let cineClose = document.getElementById('cine-close');
    if (cineClose && cineBar) cineClose.addEventListener('click', function() { cineBar.style.display = 'none'; }, { signal: _ac.signal });

    // [NEW] Cine GIF/WebM recording button
    let btnCineGif = document.getElementById('btn-cine-gif');
    if (btnCineGif) btnCineGif.addEventListener('click', async function() {
      try {
        const { exportAsGif, startVideoRecording } = await import('../ui/exportModule.js');
        // Проверяем есть ли загруженные данные
        const canvas = document.querySelector('#viewport-container canvas');
        if (!canvas) { (window.showToast||function(){})('⚠️ Сначала загрузите DICOM', 'warning'); return; }
        
        if (typeof exportAsGif === 'function') {
          (window.showToast||function(){})('🎬 Начинаю запись Cine...', 'info', 2000);
          await exportAsGif();
        } else if (typeof startVideoRecording === 'function') {
          await startVideoRecording({ mode: 'scroll' });
        }
      } catch (e) { (window.showToast||function(){})('❌ Ошибка записи: ' + e.message, 'error'); }
    }, { signal: _ac.signal });

    // [10.19.10] ТРЕТИЙ обработчик на btn-export-stl — убран.
    //
    // У одной кнопки было ТРИ хозяина, и ни один не работал: этот, как и
    // первый, звал exportSTL() без обязательного meshData (исключение уходило
    // в catch) и проверял result.blob, которого функция не возвращает. Плюс
    // подсказка в featureBindings.js. Настоящий обработчик теперь один —
    // в src/ui/toolsBindings.js, где сетка строится из активного тома.

    // Keyboard shortcuts (unique — не дублируют hotkeys.js)
    document.addEventListener('keydown', function(e) {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') return;
      let key = e.key.toLowerCase();
      // Tool shortcuts (W,H,Z,S...) — [REMOVED] дублировали hotkeys.js
      if (key === 'i') { const inv = document.getElementById('btn-invert'); if (inv) inv.click(); }
      if (key === 'o') { const rst = document.getElementById('btn-reset'); if (rst) rst.click(); }
      if (key === ' ') {
        e.preventDefault();
        import('../core/viewport.js').then(function(vp) {
          const state = vp.getCineState?.();
          if (state?.playing) {
            vp.stopCine();
            if (cineBar) cineBar.style.display = 'none';
          } else {
            vp.startCine(null, { fps: 12, loop: true });
            if (cineBar) cineBar.style.display = '';
          }
        }).catch(function() {
          if (cineBar) cineBar.style.display = cineBar.style.display === 'none' ? '' : 'none';
        });
      }
      if (e.key === 'Escape') {
        document.querySelectorAll('.modal-overlay.open').forEach(function(m) { m.classList.remove('open'); });
      }
      if (e.key === 'F11') { e.preventDefault(); const fs = document.getElementById('btn-fullscreen'); if (fs) fs.click(); }
      // Раскладки: 1, 2, 4, Q (Аудит п.8)
      let layoutMap = { '1': 'btn-layout-1x1', '2': 'btn-layout-1x2', '4': 'btn-layout-2x2', 'q': 'btn-layout-mpr' };
      if (layoutMap[key]) { const lb = document.getElementById(layoutMap[key]); if (lb) lb.click(); e.preventDefault(); }
    }, { signal: _ac.signal });

    // GPU status placeholder
    let gpuDot = document.getElementById('gpu-dot');
    let gpuTier = document.getElementById('gpu-tier-bottom');
    let gpuLabel = document.getElementById('gpu-tier-label');
    if (gpuDot) gpuDot.className = 'gpu-dot medium';
    if (gpuTier) gpuTier.textContent = 'GPU: только UI';
    if (gpuLabel) gpuLabel.textContent = 'Предпросмотр';
    let webgpuBadge = document.getElementById('webgpu-badge');
    if (isFileProtocol && webgpuBadge) {
      webgpuBadge.textContent = 'file://';
      webgpuBadge.style.background = 'rgba(234,179,8,0.15)';
      webgpuBadge.style.color = '#eab308';
    }

    // Tag search filter (offline)
    let tagSearch = document.getElementById('tag-search');
    if (tagSearch) {
      tagSearch.addEventListener('input', function() {
        let q = tagSearch.value.toLowerCase();
        document.querySelectorAll('#dicom-tags-content .tag-row').forEach(function(row) {
          row.style.display = row.textContent.toLowerCase().includes(q) ? '' : 'none';
        });
      }, { signal: _ac.signal });
    }

    // Placeholder info
    let dp = document.getElementById('drop-placeholder');
    if (dp && isFileProtocol) {
      dp.innerHTML = '<div class="drop-icon">📂</div>' +
        '<div style="font-size:14px;">Mikhmel Cornerstone4D — Предпросмотр</div>' +
        '<div style="font-size:11px; margin-top:6px; opacity:0.6;">Открыто через file:// — интерфейс полностью доступен</div>' +
        '<div style="font-size:11px; margin-top:4px; opacity:0.4;">Для работы с DICOM запустите npm run preview</div>';
    }

    // [10.19.22] Подсказка прячется по ФАКТУ СНИМКОВ, а не по появлению узла в
    // контейнере окон. Прежнее условие («в #viewport-container что-то добавили»)
    // ложно по построению: стартовая раскладка создаёт пустое окно до всякой
    // загрузки, и подсказка исчезала вместе с заставкой, оставляя пустой экран.
    // Правило одно на двоих и живёт в welcomeGate.js — там же разбор.
    if (dp) {
      let hidePlaceholder = function() { dp.style.display = 'none'; };
      import('./welcomeGate.js').then(function(m) {
        var судить = function(повод, сост) {
          var р = m.решениеОЗаставке(Object.assign({ повод: повод }, сост || {}));
          if (р.снимать) hidePlaceholder();
          return р.снимать;
        };
        import('../core/eventBus.js').then(function(bus) {
          bus.on(bus.EVENTS.STACK_LOADED, function(d) { судить(m.ПОВОДЫ.СТОПКА, { кадров: (d && (d.count || (d.imageIds && d.imageIds.length))) || 0 }); });
          bus.on(bus.EVENTS.VOLUME_LOAD_START, function(d) { судить(m.ПОВОДЫ.ТОМ, { кадров: (d && d.imageCount) || 0 }); });
          bus.on('series:selected', function() { судить(m.ПОВОДЫ.СЕРИЯ, {}); });
        }).catch(function() { /* шина событий не загрузилась — подсказка останется видимой */ });
        var список = document.getElementById('series-list');
        if (список) {
          var mo = new MutationObserver(function() {
            // Только записи серий: в пустом списке лежит заглушка, и её
            // перерисовка не означает открытого исследования.
            var n = список.querySelectorAll('.series-item, [data-series-uid]').length;
            if (судить(m.ПОВОДЫ.СПИСОК, { серий: n })) mo.disconnect();
          });
          mo.observe(список, { childList: true });
        }
      }).catch(function() { /* правило не загрузилось — подсказка останется видимой */ });
    }
  }
})();
}

// ══════════════════════════════════════════════════════════════
// ENTERPRISE FEATURES (v6) — Startup diagnostics, error analytics, perf marks
// ══════════════════════════════════════════════════════════════

/** @type {Array<{time:number, msg:string, src:string}>} */
const _errorLog = [];
const ERROR_LOG_MAX = 100;
let _startupTime = performance.now();

// Patch global error handler to log
const _origOnError = window.onerror;
window.onerror = function(msg, src, line, col, err) {
  _errorLog.push({ time: Date.now(), msg: String(msg).substring(0, 200), src: `${src}:${line}:${col}` });
  if (_errorLog.length > ERROR_LOG_MAX) _errorLog.shift();
  if (_origOnError) return _origOnError(msg, src, line, col, err);
};

/**
 * Get collected error log
 * @param {number} [last=20]
 * @returns {Array}
 */
export function getErrorLog(last = 20) { return _errorLog.slice(-last); }

/**
 * Clear error log
 */
export function clearErrorLog() { _errorLog.length = 0; }

/**
 * Get app uptime in seconds
 * @returns {number}
 */
export function getUptimeSec() { return +((performance.now() - _startupTime) / 1000).toFixed(1); }

/**
 * Get startup performance marks
 * @returns {Object}
 */
export function getPerformanceMarks() {
  const entries = performance.getEntriesByType('navigation');
  const nav = entries[0] || {};
  return {
    uptimeSec: getUptimeSec(),
    domContentLoaded: nav.domContentLoadedEventEnd ? Math.round(nav.domContentLoadedEventEnd) + 'ms' : '?',
    loadEvent: nav.loadEventEnd ? Math.round(nav.loadEventEnd) + 'ms' : '?',
    redirects: nav.redirectCount || 0,
    transferSize: nav.transferSize ? +(nav.transferSize / 1024).toFixed(0) + ' KB' : '?',
    errorCount: _errorLog.length,
  };
}

/**
 * Force reload app (hard refresh, bypass cache)
 */
export function forceReload() { location.reload(true); }

/**
 * Check if app is in standalone PWA mode
 * @returns {boolean}
 */
export function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches || !!window.navigator.standalone;
}

/**
 * Export error log as JSON file
 */
export function exportErrorLog() {
  const blob = new Blob([JSON.stringify(_errorLog, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a'); a.href = url; a.download = `errors_${Date.now()}.json`; a.click();
  URL.revokeObjectURL(url);
}

/** [FIX] Очистка глобальных слушателей appInit */
export function destroyApp() {
  if (_ac) { _ac.abort(); _ac = null; }
  window.__appInitDone = false;
}
